import { render, staticRenderFns } from "./SimpleCell.vue?vue&type=template&id=5bd2d0c6&scoped=true&"
import script from "./SimpleCell.vue?vue&type=script&lang=js&"
export * from "./SimpleCell.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCell.vue?vue&type=style&index=0&id=5bd2d0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2d0c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
